module.exports = __webpack_public_path__ + "static/media/iso.271eb288.png";